// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgb(251, 240, 223);
}

.App-logo {
  height: 12vmin;
  padding-left: 5vmin;
  pointer-events: none;
}

.Footer {
  position: fixed;
  bottom: 0;
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  color: #333440;
  width: 100vw;
  padding: .5vmin;
  z-index: 1000;
}

.Header {
  margin-top: 20vmin;
  padding-top: 20vmin;
  height: 16vmin;
  width: auto;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;


  /* position: fixed;
  height: 15%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background-color: white;
  color: #333440;
  width: 100vw;
  padding: .5vmin; */
  /* z-index: 1000; */
}

.icon {
  width: 5vw;
  height: auto;
}

.menuIcon {
  color: #333440;
  margin-left: auto;
}

.miniDeveloperText {
  color: #ed7d45;
  font-weight: bold;
}

.aboutTitle {
  font-weight: 'bold';
  /* font-size: '2vmin'; */
  color: '#333440';
}

.aboutContent {
  font-weight: 'normal';
  /* font-size: '5vw'; */
  color: '#333440';
  padding: '2vmin auto';
}

.link_text {
  color: #4F8DB9;
  /* Default color */
  font-size: 1vmin;
  text-decoration: none;
  font-weight: bold;
  font-style: italic;
  /* font-size: 1.2vw; */
}

.link_text.selected {
  color: #ed7d45;
  font-size: 1vmin;
  text-decoration: none;
  font-style: italic;
  font-weight: bold;
}

.link_text:hover {
  font-weight: bold;
  /* font-size: 1.5vw; */
  color: #ed7d45;
  text-decoration: none;
}

.course_card {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin: 2.5vmin;
}

.course_card_details {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  padding: 5vmin;
  background-color: white;
}

.course_card:hover {
  transform: scale(1.05);
  transition: transform 0.2s ease-in-out
}

.course_card_image {
  width: 100%;
  height: 200px;
  padding-bottom: 5vmin;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.course_card_bold_text {
  color: #333440;
  font-weight: bold;
}

.page_content {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  padding: 5vmin 15vmin;
  background-color: white;
}

.page_content_title {
  font-weight: bold;
  font-size: 2vw;
}

.page_content_text {
  font-weight: normal;
  font-size: 1.5vw;
}

.page_content_text_bold {
  font-weight: bold;
  font-size: 1.5vw;
}

.contentImage {
  width: 20vw;
  height: auto;
}

.subContentImage {
  width: 10vw;
  height: auto;
}

.register_form_component {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: flex-start;
  padding: 5vmin;
  background-color: white;
  width: 40vw;
}

.register_form_subcomponent {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  width: 30vw;
}

.register_form_subcomponent_withborder {
  display: flex;
  direction: row;
  background-color: white;
  width: 30vw;
  border-radius: 30;
  border: gray .3vmin solid;
  padding: 1vmin;
}

.register_form_text_field {
  display: flex;
  width: 30vw;
}

.course_details_content {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: space-evenly;
}

.course_details_content_item {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  padding: 5vmin;
}

a.social {
  margin: 0 0.3rem;
  transition: transform 250ms;
  display: inline-block;
}

a.social:hover {
  transform: translateY(-2px);
}

a.whatsapp {
  color: #23eb4b;
}

a.facebook {
  color: #4968ad;
}

a.google {
  color: #e1330c;
}

a.instagram {
  color: #f40ba6;
}

/******************************************** new CSS  ***************************************************/
.navbar {
  display: flex;
  flex-wrap: wrap;
  /* Allows items to wrap to a new line if needed */
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}

.drawer {
  width: 'auto';
  color: #007bff;
  font-weight: bold;
  padding: 0.5rem 1rem;
}

.navbar-item {
  margin: 0.5rem;
  text-decoration: none;
  color: #007bff;
}

.header {
  padding-top: 1vmin;
  height: 11vmin;
  width: auto;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer {
  height: 10vmin;
  width: auto;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2vmin;
}

.routes-container {
  padding: 2vmin;
}

.home-page-block {
  height: 75vmin;
  position: relative;
  overflow: hidden;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin: 2vmin auto; */
}

.home-page-block video {
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.home-page-block .coding-vedio-section {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  opacity: 0.9;
}

.home-page-block .coding-vedio-section h1 {
  font-size: 5vmin;
  color: white;
  position: relative;
  opacity: 0.9;
}

.home-page-block .coding-vedio-section h2 {
  font-size: 4vmin;
  font-style: italic;
  color: white;
  position: relative;
}

.ads-box {
  height: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #3498db;
  color: white;
  font-size: 2vmin;
  width: 100%;
  /* Name, duration, timing function, delay, repeat, direction, fill mode */
  animation: changeColor .5s ease-in-out 1s infinite alternate both;
}

/* Animation Definition */
@keyframes changeColor {
  0% {
    background-color: #3498db;
  }

  100% {
    background-color: #e74c3c;
  }
}

.brown_btn {
  border-radius: 10;
  background: linear-gradient(to bottom, #e09b79, #9e532d);
  font-size: 1.5vmin;
  /* color: #5f6276; */
  font-weight: bold;
  width: max-content;
}

.orage_btn {
  border-radius: 10;
  background: linear-gradient(to bottom, #ffb093, #ed7d45);
  font-size: 1.5vmin;
  font-weight: bold;
  width: max-content;
}

.gray_btn {
  border-radius: 10;
  background: linear-gradient(to bottom, #d6d7de, #b2b2b2);
  font-size: 1.5vmin;
  margin: '2vw';
  /* color: #5f6276; */
  font-weight: bold;
  width: max-content;
}

.blue_btn {
  border-radius: 10;
  background: #1105ef;
  font-size: 1.5vmin;
  font-weight: bold;
  width: max-content;
  padding: 1vmin;
}

.black_btn {
  border-radius: 10;
  background: linear-gradient(to bottom, #333440, #333440);;
  font-size: 1.5vmin;
  font-weight: bold;
  width: 35%;
  padding: 1vmin;
}

.page_content_dark {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  padding: 5vmin;
  background-color: #333440;
  /* margin: 2vmin auto; */
}

.page_content {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  padding: 5vmin ;
  background-color: white;
}

.page_content_title {
  font-weight: bold;
  font-size: 2vw;
}

.page_content_text {
  font-weight: normal;
  font-size: 1.5vw;
}

.page_content_text_bold {
  font-weight: bold;
  font-size: 1.5vw;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;;EAGnB;;;;;;;;oBAQkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,0GAA0G;AAC1G;EACE,aAAa;EACb,eAAe;EACf,iDAAiD;EACjD,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,yEAAyE;EACzE,iEAAiE;AACnE;;AAEA,yBAAyB;AACzB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,wDAAwD;EACxD,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,wDAAwD;EACxD,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,wDAAwD;EACxD,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wDAAwD;EACxD,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".App {\n  text-align: center;\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: rgb(251, 240, 223);\n}\n\n.App-logo {\n  height: 12vmin;\n  padding-left: 5vmin;\n  pointer-events: none;\n}\n\n.Footer {\n  position: fixed;\n  bottom: 0;\n  height: 20%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  color: #333440;\n  width: 100vw;\n  padding: .5vmin;\n  z-index: 1000;\n}\n\n.Header {\n  margin-top: 20vmin;\n  padding-top: 20vmin;\n  height: 16vmin;\n  width: auto;\n  background-color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n\n  /* position: fixed;\n  height: 15%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  background-color: white;\n  color: #333440;\n  width: 100vw;\n  padding: .5vmin; */\n  /* z-index: 1000; */\n}\n\n.icon {\n  width: 5vw;\n  height: auto;\n}\n\n.menuIcon {\n  color: #333440;\n  margin-left: auto;\n}\n\n.miniDeveloperText {\n  color: #ed7d45;\n  font-weight: bold;\n}\n\n.aboutTitle {\n  font-weight: 'bold';\n  /* font-size: '2vmin'; */\n  color: '#333440';\n}\n\n.aboutContent {\n  font-weight: 'normal';\n  /* font-size: '5vw'; */\n  color: '#333440';\n  padding: '2vmin auto';\n}\n\n.link_text {\n  color: #4F8DB9;\n  /* Default color */\n  font-size: 1vmin;\n  text-decoration: none;\n  font-weight: bold;\n  font-style: italic;\n  /* font-size: 1.2vw; */\n}\n\n.link_text.selected {\n  color: #ed7d45;\n  font-size: 1vmin;\n  text-decoration: none;\n  font-style: italic;\n  font-weight: bold;\n}\n\n.link_text:hover {\n  font-weight: bold;\n  /* font-size: 1.5vw; */\n  color: #ed7d45;\n  text-decoration: none;\n}\n\n.course_card {\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  margin: 2.5vmin;\n}\n\n.course_card_details {\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n  padding: 5vmin;\n  background-color: white;\n}\n\n.course_card:hover {\n  transform: scale(1.05);\n  transition: transform 0.2s ease-in-out\n}\n\n.course_card_image {\n  width: 100%;\n  height: 200px;\n  padding-bottom: 5vmin;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.course_card_bold_text {\n  color: #333440;\n  font-weight: bold;\n}\n\n.page_content {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center;\n  align-items: center;\n  padding: 5vmin 15vmin;\n  background-color: white;\n}\n\n.page_content_title {\n  font-weight: bold;\n  font-size: 2vw;\n}\n\n.page_content_text {\n  font-weight: normal;\n  font-size: 1.5vw;\n}\n\n.page_content_text_bold {\n  font-weight: bold;\n  font-size: 1.5vw;\n}\n\n.contentImage {\n  width: 20vw;\n  height: auto;\n}\n\n.subContentImage {\n  width: 10vw;\n  height: auto;\n}\n\n.register_form_component {\n  display: flex;\n  flex-flow: column wrap;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 5vmin;\n  background-color: white;\n  width: 40vw;\n}\n\n.register_form_subcomponent {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: center;\n  background-color: white;\n  width: 30vw;\n}\n\n.register_form_subcomponent_withborder {\n  display: flex;\n  direction: row;\n  background-color: white;\n  width: 30vw;\n  border-radius: 30;\n  border: gray .3vmin solid;\n  padding: 1vmin;\n}\n\n.register_form_text_field {\n  display: flex;\n  width: 30vw;\n}\n\n.course_details_content {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: flex-start;\n  justify-content: space-evenly;\n}\n\n.course_details_content_item {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n  justify-content: center;\n  padding: 5vmin;\n}\n\na.social {\n  margin: 0 0.3rem;\n  transition: transform 250ms;\n  display: inline-block;\n}\n\na.social:hover {\n  transform: translateY(-2px);\n}\n\na.whatsapp {\n  color: #23eb4b;\n}\n\na.facebook {\n  color: #4968ad;\n}\n\na.google {\n  color: #e1330c;\n}\n\na.instagram {\n  color: #f40ba6;\n}\n\n/******************************************** new CSS  ***************************************************/\n.navbar {\n  display: flex;\n  flex-wrap: wrap;\n  /* Allows items to wrap to a new line if needed */\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 1rem;\n}\n\n.drawer {\n  width: 'auto';\n  color: #007bff;\n  font-weight: bold;\n  padding: 0.5rem 1rem;\n}\n\n.navbar-item {\n  margin: 0.5rem;\n  text-decoration: none;\n  color: #007bff;\n}\n\n.header {\n  padding-top: 1vmin;\n  height: 11vmin;\n  width: auto;\n  background-color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.footer {\n  height: 10vmin;\n  width: auto;\n  background-color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 2vmin;\n}\n\n.routes-container {\n  padding: 2vmin;\n}\n\n.home-page-block {\n  height: 75vmin;\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* margin: 2vmin auto; */\n}\n\n.home-page-block video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n}\n\n.home-page-block .coding-vedio-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  position: relative;\n  opacity: 0.9;\n}\n\n.home-page-block .coding-vedio-section h1 {\n  font-size: 5vmin;\n  color: white;\n  position: relative;\n  opacity: 0.9;\n}\n\n.home-page-block .coding-vedio-section h2 {\n  font-size: 4vmin;\n  font-style: italic;\n  color: white;\n  position: relative;\n}\n\n.ads-box {\n  height: 15%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #3498db;\n  color: white;\n  font-size: 2vmin;\n  width: 100%;\n  /* Name, duration, timing function, delay, repeat, direction, fill mode */\n  animation: changeColor .5s ease-in-out 1s infinite alternate both;\n}\n\n/* Animation Definition */\n@keyframes changeColor {\n  0% {\n    background-color: #3498db;\n  }\n\n  100% {\n    background-color: #e74c3c;\n  }\n}\n\n.brown_btn {\n  border-radius: 10;\n  background: linear-gradient(to bottom, #e09b79, #9e532d);\n  font-size: 1.5vmin;\n  /* color: #5f6276; */\n  font-weight: bold;\n  width: max-content;\n}\n\n.orage_btn {\n  border-radius: 10;\n  background: linear-gradient(to bottom, #ffb093, #ed7d45);\n  font-size: 1.5vmin;\n  font-weight: bold;\n  width: max-content;\n}\n\n.gray_btn {\n  border-radius: 10;\n  background: linear-gradient(to bottom, #d6d7de, #b2b2b2);\n  font-size: 1.5vmin;\n  margin: '2vw';\n  /* color: #5f6276; */\n  font-weight: bold;\n  width: max-content;\n}\n\n.blue_btn {\n  border-radius: 10;\n  background: #1105ef;\n  font-size: 1.5vmin;\n  font-weight: bold;\n  width: max-content;\n  padding: 1vmin;\n}\n\n.black_btn {\n  border-radius: 10;\n  background: linear-gradient(to bottom, #333440, #333440);;\n  font-size: 1.5vmin;\n  font-weight: bold;\n  width: 35%;\n  padding: 1vmin;\n}\n\n.page_content_dark {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center;\n  align-items: center;\n  padding: 5vmin;\n  background-color: #333440;\n  /* margin: 2vmin auto; */\n}\n\n.page_content {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center;\n  align-items: center;\n  padding: 5vmin ;\n  background-color: white;\n}\n\n.page_content_title {\n  font-weight: bold;\n  font-size: 2vw;\n}\n\n.page_content_text {\n  font-weight: normal;\n  font-size: 1.5vw;\n}\n\n.page_content_text_bold {\n  font-weight: bold;\n  font-size: 1.5vw;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
